// --------------pagination code-----------------
document.addEventListener("DOMContentLoaded", function () {

  let isAllView = false;

  const pageBtn = document.querySelector(".tps-page-link");

  const swiperWrap = document.getElementById("tps-swiper-wrap");
  const paginationWrap = document.getElementById("tps-pagination");
  const grid = document.getElementById("tps-all-grid");
  const heading = document.getElementById("tps-heading");

  const topPostSections = document.querySelectorAll("#top_post_wrapper");

  let swiperInstance = null;

  function initSwiperAgain() {
    if (typeof Swiper === "undefined") return;

    swiperInstance = new Swiper(".top-posts-swiper", {
      slidesPerView: 1,
      spaceBetween: 24,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      }
    });
  }

  /* ───── ALL BLOG VIEW ───── */
  function showAllBlogs() {
    isAllView = true;

    if (swiperWrap) swiperWrap.style.display = "none";
    if (paginationWrap) paginationWrap.style.display = "none";

    topPostSections.forEach(function (sec) {
      sec.style.display = "none";
    });

    if (grid) grid.style.display = "grid";

    if (heading) heading.textContent = "All Blogs";

    /* Active filter button style */
    const activeBtn = document.querySelector(".filter-btn.active");
    if (activeBtn) {
      activeBtn.style.background = "#f3f3f3";
      activeBtn.style.color = "#555";
    }
  }

  /* ───── RECENT VIEW RESTORE ───── */
  function showRecentPosts() {
    isAllView = false;

    if (grid) {
      grid.style.display = "none";
      grid.innerHTML = "";
    }

    if (swiperWrap) swiperWrap.style.display = "";
    if (paginationWrap) paginationWrap.style.display = "";

    topPostSections.forEach(function (sec) {
      sec.style.display = "";
    });

    if (heading) heading.textContent = "Recent Posts";

    document.querySelectorAll(".filter-btn").forEach(function (btn) {
      btn.classList.remove("active");
      btn.style.background = "";
      btn.style.color = "";
    });

    const allBtn = document.querySelector('[data-tag="all"]');
    if (allBtn) allBtn.classList.add("active");

    document.querySelectorAll(".pagination__btn").forEach(function (p) {
      p.classList.remove("active");
    });

    setTimeout(function () {
      initSwiperAgain();
    }, 50);
  }

  /* ───── EVENTS ───── */

  if (pageBtn) {
    pageBtn.addEventListener("click", function (e) {
      e.preventDefault();
      showAllBlogs();
    });
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".filter-btn.active");

    if (btn && isAllView) {
      showRecentPosts();
    }
  });

  /* Hover effect */
  document.addEventListener("mouseover", function (e) {
    const btn = e.target.closest(".filter-btn.active");
    if (btn && isAllView) {
      btn.style.background = "#f3f3f3";
      btn.style.color = "#555";
    }
  });

  /* INIT */
  setTimeout(function () {
    initSwiperAgain();
  }, 50);

});
// -----------------sub class="sub-filter-btn active" code 

document.addEventListener('DOMContentLoaded', function () {

  function checkActiveFilter() {
    const activeSubFilter = document.querySelector('.sub-filter-btn.active');

    if (activeSubFilter) {

      // Hide wrappers
      document.querySelectorAll('#top_post_wrapper, #recent_top_post_wrapper')
        .forEach(function(el) {
          el.style.setProperty('display', 'none', 'important');
        });

      // Hide all Shopify Top Post sections
      document.querySelectorAll('[id*="top_post_cstm"]')
        .forEach(function(el) {
          el.style.setProperty('display', 'none', 'important');
        });

    } else {

      // Show wrappers back
      document.querySelectorAll('#top_post_wrapper, #recent_top_post_wrapper')
        .forEach(function(el) {
          el.style.display = '';
        });

      // Show Shopify Top Post sections back
      document.querySelectorAll('[id*="top_post_cstm"]')
        .forEach(function(el) {
          el.style.display = '';
        });
    }
  }

  // Initial page load
  checkActiveFilter();

  // Check after filter clicks
  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.sub-filter-btn') ||
      e.target.closest('.parent-btn') ||
      e.target.closest('.filter-btn')
    ) {
      setTimeout(checkActiveFilter, 100);
      setTimeout(checkActiveFilter, 300);
      setTimeout(checkActiveFilter, 500);
    }
  });

  // Observe active class changes
  const observer = new MutationObserver(checkActiveFilter);

  document.querySelectorAll('.sub-filter-btn').forEach(function (btn) {
    observer.observe(btn, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

});
// -----------end---------